export interface Profession {
  value: string;
  label: string;
  council: string | null;
}

export const ALL_PROFESSIONS: Profession[] = [
  { value: "medicina", label: "Medicina", council: "CRM" },
  { value: "assistencia-social", label: "Assistência Social", council: "CRESS/CFESS" },
  { value: "biologia", label: "Biologia", council: "CRBio" },
  { value: "biomedicina", label: "Biomedicina", council: "CRBM" },
  { value: "educacao-fisica", label: "Educação Física", council: "CREF" },
  { value: "enfermagem", label: "Enfermagem", council: "COREN" },
  { value: "farmacia", label: "Farmácia", council: "CRF" },
  { value: "fisioterapia", label: "Fisioterapia", council: "CREFITO" },
  { value: "fonoaudiologia", label: "Fonoaudiologia", council: "CRFa" },
  { value: "nutricao", label: "Nutrição", council: "CRN" },
  { value: "odontologia", label: "Odontologia", council: "CRO" },
  { value: "psicologia", label: "Psicologia", council: "CRP" },
  { value: "terapia-ocupacional", label: "Terapia Ocupacional", council: "CREFITO" },
  { value: "quiropraxia", label: "Quiropraxia", council: null },
  { value: "gerontologia", label: "Gerontologia", council: null },
  { value: "obstetricia", label: "Obstetrícia", council: null },
  { value: "rolfismo", label: "Rolfismo", council: null },
  { value: "psicanalise", label: "Psicanálise", council: null },
  { value: "psicopedagogia", label: "Psicopedagogia", council: null },
  { value: "acupuntura", label: "Acupuntura", council: null },
];

export const PROFESSION_CERTIFICATE_DESCRIPTION: Partial<Record<string, string>> = {
  biologia:
    "Certidão emitida pelo CRBio declarando que o profissional está habilitado para atuar em estética.",
  biomedicina:
    "Certificado com título de especialista em estética, obtido ou reconhecido pela ABBM ou Certificado de pós-graduação (lato ou stricto sensu) ou Habilitação em Práticas Integrativas e complementares em Saúde (PICS).",
  enfermagem: "Certificado de pós-graduação em estética.",
  farmacia:
    "Certificado de pós-graduação em saúde estética ou Curso livre em estética reconhecido pelo CFF.",
  fisioterapia:
    "Certificado emitido pelo COFITO em fisioterapia dermatofuncional. Para aplicação de toxina botulínica na área de Fisioterapia Dermatofuncional: formação específica em cursos de capacitação reconhecidos pelo COFITO, com carga mínima de 50 horas. Para aplicação de toxina botulínica na área de Fisioterapia Neurofuncional: formação específica em cursos de capacitação reconhecidos pelo COFITO, com carga mínima de 70 horas.",
  odontologia:
    "Especialização em Harmonização Orofacial com carga mínima de 500 horas ou Registro no Conselho Federal como Especialista em HOF.",
};

export const PROFESSIONS_WITH_CERTIFICATE = new Set(
  Object.keys(PROFESSION_CERTIFICATE_DESCRIPTION),
);

export const PROFESSION_WITHOUT_COUNCIL_DOCUMENTS = new Map<string, string[]>([
  [
    "psicopedagogia",
    [
      "Diploma em Pedagogia + Título de Especialização em áreas clínicas relacionadas, como Psicopedagogia, Neuropsicopedagogia ou Intervenção ABA",
      "Diploma de Curso Superior em Psicopedagogia",
    ],
  ],
  [
    "acupuntura",
    [
      "Título de Especialista concedido pelo Programa de Residência Médica em Acupuntura",
      "Concurso do Convênio AMB/Colégio Médico de Acupuntura",
      "Certificado de conclusão de graduação em acupuntura/ciências da acupuntura reconhecidos pelo MEC",
      "Curso livre ou curso técnico com certificado de carga horária mínima de 600 horas/aula teóricas e 300 horas/aula de prática ambulatorial",
    ],
  ],
  [
    "gerontologia",
    [
      "Vínculo com a Associação Brasileira de Gerontologia (ABG) ou título emitido pela Sociedade Brasileira de Geriatria e Gerontologia (SBGG)",
    ],
  ],
  ["obstetricia", ["Diploma de Curso Superior em Obstetrícia"]],
  ["rolfismo", ["Vínculo com a Associação Brasileira de Rolfing"]],
  ["psicanalise", ["Certificado de formação em Psicanálise com carga horária mínima de 600 horas"]],
  [
    "quiropraxia",
    [
      "Vínculo com a Associação Brasileira de Quiropraxia (ABQ)",
      "Diploma do Curso Superior em Quiropraxia",
    ],
  ],
]);

